<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import moment from 'moment';
import Swal from "sweetalert2";
export default {
  components: { ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Partial Payment List",
      items: [
        {
          text: "Partial Payment",
          href: "/",
        },
        {
          text: "List",
          active: true,
        },
      ],
      partialPayments: [],
        alladmins:[],
        admins:[],
        user_type:"",
        user_id:"",
        request_status:"",
        payment_status:"",
        creation_startdate:"",
        creation_enddate:"",
        request_startdate:"",
        request_enddate:"",
        due_startdate:"",
        due_enddate:"",
        remarks:"",
        expired:"",
        errors: null,
        visible:false,
        display_div:true,
        message:"",
        pin:"",
        partial_amount:"",
        due_date:"",
        expiry_date:"",
        search_payment_ref:"",
        search_booking_ref:"",
        search_username:"",
    };
  },
    created() {
        this.request_status = this.$route.params.status;
        this.user_id=this.$route.params.user_id;
    },
  mounted() {
      if(this.user_id != undefined){
          this.getUserID();
          this.display_div=false;
      }
    this.search();
    this.getAdminList();
  },
    computed: {
        filteredList() {
            return this.partialPayments.filter(payment => {
                return (payment.reference==null ? '' : payment.reference).toLowerCase().includes(this.search_payment_ref.toLowerCase())
                     && (payment.user.username==null ? '' : payment.user.username).toLowerCase().includes(this.search_username.toLowerCase())
                    && (payment.booking_ref==null ? '' : payment.booking_ref).toLowerCase().includes(this.search_booking_ref.toLowerCase())
            })
        }
    },
    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search1=val;
        },
        toggleDiv: function() {
            this.display_div = !this.display_div;
        },
        async getUserID() {
            try {
                axios
                    .post("/api/get-user-id/" + this.user_id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.status) {
                            this.user_id=parseInt(response.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
    async search() {
      try {
        axios
          .get("/api/partial-payment-request", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
                user_type: this.user_type,
                user_id:this.user_id,
                expired:this.expired,
                request_status:this.request_status,
                payment_status:this.payment_status,
                creation_startdate:this.creation_startdate,
                creation_enddate:this.creation_enddate,
                request_startdate:this.request_startdate,
                request_enddate:this.request_enddate,
                due_startdate:this.due_startdate,
                due_enddate:this.due_enddate,
            },
          })
          .then((response) => {
            if (response.data.status) {
               // this.partialPayments=response.data.data;
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    if(temp[i].request_status=='pending'){
                       arr.push(temp[i]);
                    }
                }
                for (i=0;i<temp.length;i++){
                    if(temp[i].request_status!='pending'){
                        arr.push(temp[i]);
                    }
                }
                this.partialPayments=arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
        async rejectPartialPayment(id) {
            try {
                axios
                    .post("/api/partial-payment-reject", {
                        accessToken: localStorage.getItem("access_tocken"),
                        id: id,
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Partial Payment Rejected Successfully");
                            this.search();
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async partialPaymentRejectWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Reject Partial Payment!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.rejectPartialPayment(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async getAdminList() {
            try {
                axios
                    .get("/api/user/approved/list", {
                        params: {
                            accessToken: localStorage.getItem("access_tocken"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status) {
                            let temp=response.data.data;
                            let i;
                            let arr=[];
                            for (i=0;i<temp.length;i++){
                                if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                    if(temp[i].approved_agents[0].approval_status=='approved') {
                                        temp[i].value = temp[i].id;
                                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                        arr.push(temp[i]);
                                    }
                                }
                                if(temp[i].account_type=='b2c'){
                                    if(temp[i].first_name==null){
                                        temp[i].text=temp[i].email + '(unregistered)';
                                    }else{
                                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                    }
                                    temp[i].value = temp[i].id;
                                    arr.push(temp[i]);
                                }

                            }
                            this.alladmins=arr;
                            this.admins = arr;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async cancelBookingMicroserviceWarning(id) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    type: "error",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Cancel Booking!",
                    cancelButtonText: "No",
                    showCloseButton: true,
                    showLoaderOnConfirm: true,
                }).then((result) => {
                    if (result.value) {
                        _this.cancelBookingMicroservice(id);
                    } else {
                        this.$swal("Cancelled", "", "info");
                    }
                });
            } catch (err) {
                console.log(err);
            }
        },
        async cancelBookingMicroservice(id) {
            try {
                axios
                    .post("/api/flight-booking/booking-cancel-microservice/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Booking Cancelled Successfully");
                            this.search();
                        } else {
                            this.$swal("Booking Not Cancelled");
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        onChange(event) {
            this.user_type=event.target.value;
            var temp=this.alladmins;
            var arr=[];
            var i;
            for (i=0;i<temp.length;i++){
                if (temp[i].account_type==event.target.value){
                    arr.push(temp[i]);
                }
            }
            this.admins = arr;
        },
        async clear() {
            this.user_type="";
            this.user_id="";
            this.creation_startdate="";
            this.creation_enddate="";
            this.request_startdate="";
            this.request_enddate="";
            this.due_startdate="";
            this.due_enddate="";
            this.request_status="";
            this.payment_status="";
            this.admins=this.alladmins;
        },
        async confirmPayment(payment) {
            var _this = this;
            try {
                this.$swal({
                    title: "Are you sure?",
                    text: "You can't revert your action",
                    html:
                        '<input type="text" id="swal-input1"  type="password" class="swal2-input" placeholder="Enter your pin">' +
                        '<input type="text" id="swal-input2" class="swal2-input" placeholder="Type Partial Amount">'+
                        '<input type="text" id="swal-input4" class="swal2-input" placeholder="Enter Expiry Date Time">'+
                        '<input type="text" id="swal-input3" class="swal2-input" placeholder="Enter Due Date Time">'+
                        '<input type="text" id="swal-input5" class="swal2-input" placeholder="Type Remarks">'
                    ,
                    preConfirm: function () {
                        var as='';
                        return new Promise(function (resolve) {
                            resolve([$("#swal-input1").val()=='' ? as+='Pin is not set<br>':$("#swal-input1").val() ,
                                $("#swal-input2").val()=='' ? as+='partial amount not set<br>' : $("#swal-input2").val(),
                                $("#swal-input3").val()=='' ? as+='Due date time not set<br>' : $("#swal-input3").val() ,
                                $("#swal-input4").val()=='' ? as+='Expiry date time not set<br>' : $("#swal-input4").val(),
                                $("#swal-input5").val()=='' ? as+='Remarks not set<br>' : $("#swal-input5").val()]);
                            if(as != ''){
                                Swal.showValidationMessage(as)
                            }
                        });
                    },
                    onOpen: function () {
                        $("#swal-input1").focus();
                        $('#swal-input4').datetimepicker({
                            inline:false,
                            closeOnDateSelect: true,
                            minDateTime:new Date()
                        });
                        $('#swal-input3').datetimepicker({
                          inline:false,
                            closeOnDateSelect: true,
                            minDateTime:new Date()
                        });


                    },
                })
                    .then(function (result) {
                        if (
                            result.isConfirmed &&
                            result.value[0] != "" &&
                            result.value[1] != "" &&
                            result.value[2] != "" &&
                            result.value[3] != "" &&
                            result.value[4] != ""
                        ) {
                            _this.pin = result.value[0];
                            _this.partial_amount = result.value[1];
                            _this.due_date= result.value[2];
                            _this.expiry_date=result.value[3];
                            _this.remarks=result.value[4];
                            _this.confirm(payment.id);
                        } else {
                            _this.$swal("Cancelled", "Amount is not set", "info");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        confirm(id){
            axios
                .post("/api/partial-payment-set-amount", {
                    id: id,
                    pin: this.pin,
                    partial_amount:this.partial_amount,
                    due_date:this.due_date,
                    expiry_date:this.expiry_date,
                    remarks:this.remarks,
                    accessToken: localStorage.getItem("access_tocken"),
                })
                .then((response) => {
                    if (response.data.status) {

                        this.$swal("Good job!", "Partial Amount Set", "success");
                        this.search();

                    } else {
                        var str = response.data.message;
                        var jsonParse = JSON.parse(str);
                        this.errorCheck(jsonParse);
                    }
                })
                .catch((error) => {
                    if (error.response != undefined) {
                        this.errors = error.response.data.errors;
                    }
                })
        },
    errorCheck(obj) {
          if(obj.message=='PIN doesn\'t match'){
              this.$swal("Error", "PIN doesn't match", "error");
          }
        if(obj.message=='total amount is bigger than partial amount'){
            this.$swal("Error", "Partial Amount must be less than total amount", "error");
        }
        if(obj.message=='Due date must be greater than expiry date'){
            this.$swal("Error", "Due date must be greater than expiry date", "error");
        }
        if(obj.message=='need to create PIN first'){
            this.$swal("Error", "need to create PIN first", "error");
        }
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <h4 class="card-title">Partial Payment List</h4>
            <div v-if="display_div" class="row">

                <div class="col-md-4">
                    <div class="form-group">
                        <label>Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            @change="onChange($event)"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Select User</label>
                        <model-select :options="admins"
                                      v-model="user_id"
                                      placeholder="Select User">
                        </model-select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Select Expired</label>
                        <select
                            id="request_status"
                            name="request_status"
                            v-model="expired"
                            class="form-control"
                            placeholder="Type Status">
                            <option value="partial">Partial Payment
                            </option>
                            <option value="full">Full Payment
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Select Partial Payment Request Status</label>
                        <select
                            id="request_status"
                            name="request_status"
                            v-model="request_status"
                            class="form-control"
                            placeholder="Type Status">
                            <option value="pending">Request Pending
                            </option>
                            <option value="confirmed">Request Confirmed
                            </option>
                            <option value="rejected">Request Rejected
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Select Full Payment Status</label>
                        <select
                            id="payment_status"
                            name="payment_status"
                            v-model="payment_status"
                            class="form-control"
                            placeholder="Select User Type">
                            <option value="unpaid">Un Paid
                            </option>
                            <option value="partially-paid">Partially Paid
                            </option>
                            <option value="paid">Paid
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="start-datepicker1">Creation Start Date</label>
                        <b-form-datepicker id="start-datepicker1" v-model="creation_startdate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="end-datepicker1">Creation End Date</label>
                        <b-form-datepicker id="end-datepicker1" v-model="creation_enddate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="start-datepicker2">Expiry Start Date</label>
                        <b-form-datepicker id="start-datepicker2" v-model="request_startdate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="end-datepicker2">Expiry End Date</label>
                        <b-form-datepicker id="end-datepicker2" v-model="request_enddate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="start-datepicker3">Due Start Date</label>
                        <b-form-datepicker id="start-datepicker3" v-model="due_startdate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <label for="end-datepicker3">Due End Date</label>
                        <b-form-datepicker id="end-datepicker3" v-model="due_enddate" class="mb-2"></b-form-datepicker>
                    </div>
                </div>
                <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Partial Payment List</h4>
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                      <th>Partial Payment Ref</th>
                      <th>Username</th>
                      <th>Booking Ref</th>
                      <th>Booking Status</th>
                      <th>Total Amount</th>
                    <th>Partial Amount</th>
                    <th>Due Amount</th>
                      <th>Due Date</th>
                      <th>Expiry Date</th>
                      <th>Request DateTime</th>
                      <th>Status</th>
                      <th>Action</th>

                  </tr>
                  <tr>
                      <td> &nbsp </td>
                      <td><input type="text" class="app-search form-control" v-model="search_payment_ref" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_username" placeholder="Search " /></td>
                      <td><input type="text" class="app-search form-control" v-model="search_booking_ref" placeholder="Search " /></td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>

                      <td> &nbsp</td>
                      <td> &nbsp </td>
                      <td> &nbsp </td>

                  </tr>

                </thead>
                <tbody>
                  <tr v-for="(partialPayment,index) in filteredList"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="partialPayment.reference!=null">{{partialPayment.reference}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.user!=null">
                          <div v-if="partialPayment.account_type==='b2b'" class="row">
                              <div v-if="partialPayment.user.username!=null" class="col-xs-4">{{partialPayment.agency_name}}</div>
                          </div>
                          <div v-if="partialPayment.account_type==='b2c'" class="row">
                              <div v-if="partialPayment.user.username!=null" class="col-xs-4">{{partialPayment.user.first_name+" "+partialPayment.user.last_name+"("+partialPayment.user.account_type+")"}}</div>
                          </div>
                          <div class="row">
                              <div class="col-xs-4"><router-link  :to="{ name: 'admin_agent_details', params: {id: partialPayment.user.id } }" target="_blank" >{{partialPayment.user.username==null ? 'N/A' : partialPayment.user.username}}</router-link></div>
                          </div>
                      </td>
<!--                      <td v-if="partialPayment.user!=null">{{partialPayment.user.first_name+" "+partialPayment.user.last_name}}<router-link  :to="{ name: 'admin_agent_details', params: {id: partialPayment.user.id } }" target="_blank" >{{partialPayment.user.username==null ? 'N/A' : partialPayment.user.username}}</router-link></td>-->
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.booking_ref!=null">{{partialPayment.booking_ref}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.booking!=null">
                          <div class="row">
                              <div class="col-xs-4">
                                  <b-badge v-if="partialPayment.booking.booking_status_id===7" variant="success" class="ml-1">{{partialPayment.booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="partialPayment.booking.booking_status_id===5" variant="primary" class="ml-1">{{partialPayment.booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="partialPayment.booking.booking_status_id===2" variant="warning" class="ml-1">{{partialPayment.booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else-if="partialPayment.booking.booking_status_id===3" variant="danger" class="ml-1">{{partialPayment.booking.booking_status.status_name}}</b-badge>
                                  <b-badge v-else variant="dark" class="ml-1">{{partialPayment.booking.booking_status.status_name}}</b-badge>
                              </div>
                          </div>
                          </td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.total_amount!=null">{{partialPayment.total_amount}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.partial_amount!=null">{{partialPayment.partial_amount}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.due_amount!=null">{{partialPayment.due_amount}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.due_date_time!=null">{{partialPayment.due_date_time|  moment("D MMM YYYY, H:mm")}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.expiry_date_time!=null">{{partialPayment.expiry_date_time|  moment("D MMM YYYY, H:mm")}}</td>
                      <td v-else>N/A</td>
                      <td v-if="partialPayment.requested_date_time!=null">{{partialPayment.requested_date_time|  moment("D MMM YYYY, H:mm")}}</td>
                      <td v-else>N/A</td>
                      <td>
                      <p v-if="partialPayment.request_status=='pending' && partialPayment.payment_status=='unpaid' && (partialPayment.booking.booking_status.status_tag=='booking-confirmed' || partialPayment.booking.booking_status.status_tag=='canceled')"><b-badge variant="warning">Pending </b-badge></p>
                      <p v-if="partialPayment.request_status=='confirmed' && partialPayment.payment_status=='partially-paid'"><b-badge variant="success">Partially Paid </b-badge></p>
                          <p v-if="partialPayment.request_status=='confirmed' && partialPayment.payment_status=='unpaid'"><b-badge variant="primary">Not Paid </b-badge></p>
                      <p v-if="partialPayment.request_status=='confirmed' && partialPayment.payment_status=='paid'"><b-badge variant="success">Full Paid </b-badge></p>
                          <p v-if="partialPayment.request_status=='rejected'"><b-badge variant="danger">Rejected </b-badge></p>
                      </td>
                      <td>
                          <button v-if="partialPayment.request_status == 'pending'" @click.prevent="confirmPayment(partialPayment)" class="btn btn-success btn-small"> Confirm</button>
                          <button v-if="partialPayment.request_status == 'pending'" class="btn btn-danger btn-small" @click.prevent="partialPaymentRejectWarning(partialPayment.id)">Reject</button>
                          <button v-if="partialPayment.request_status=='confirmed' && (partialPayment.payment_status=='partially-paid' || partialPayment.payment_status=='unpaid') && partialPayment.booking.booking_status.status_tag=='booking-confirmed'" class="btn btn-primary btn-sm" @click.prevent="cancelBookingMicroserviceWarning(partialPayment.booking.id)">dCancel</button>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
#swal-input3 {
    display: inline-block;
}
.swal2-input {
    display: initial;
    width: 400px;
    height: 40px;
    margin: 10px;
}
</style>
<!--<style scoped>-->

<!--.btn{-->
<!--    margin-left:4%;-->
<!--}-->
<!--.button-padding{-->
<!--    margin-top:6%;-->
<!--}-->
<!--#datepicker {-->
<!--    display: inline-block;-->
<!--}-->
<!--.float-right{-->
<!--    float: right;-->
<!--}-->
<!--</style>-->
<!--<link rel="stylesheet" type="text/css" href="jquery.datetimepicker.css"/>-->
<!--<script src="http://ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js"></script>-->
<!--<script src="jquery.datetimepicker.js"></script>-->
